import React, { Component } from 'react';
import { Modal, Input } from 'antd';
import { inject, observer } from "mobx-react";
import "./index.scss";

const { TextArea } = Input;

@inject('store')
@observer
class index extends Component {
    render() {
        const { visible, onCancel } = this.props.store.applyexpress;
        const { data } = this.props;

        return (
            <Modal
                title="查看物流"
                visible={visible}
                onCancel={onCancel}
                cancelText="取消"
                okText="提交"
                className="apply-express"
            >
                <p className="order-no">订单编号：{data.out_trade_no}</p>
                <p>
                    <span className="billing-name">物流公司:</span>
                    <span className="billing-value">{data.express}</span>
                </p>
                <p>
                    <span className="billing-name">物流单号:</span>
                    <span className="billing-value">{data.express_no}</span>
                </p>
            </Modal>
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/user/Logistics/index.js